import type { ReactNode } from 'react';
import { cn } from '@/lib/utils';
import { MoneyFoxLogo } from '@/shared/components/moneyfox-logo';
import { QuizBackButton } from './quiz-back-button';

interface QuizStepHeaderProps {
  onBack: () => void;
  title?: string;
  trailing?: ReactNode;
  children?: ReactNode;
  className?: string;
}

/** Sticky quiz chrome — same fill as the page so content does not show through. */
export function QuizStepHeader({
  onBack,
  title,
  trailing,
  children,
  className,
}: QuizStepHeaderProps) {
  return (
    <header
      className={cn(
        'sticky top-0 z-20 flex flex-col gap-3 bg-mf-neutral-50 px-4 py-3',
        className,
      )}
    >
      <div
        aria-hidden="true"
        className="pointer-events-none absolute inset-0 bg-mf-neutral-50"
      />
      <div className="relative z-10 flex items-center justify-between">
        <QuizBackButton onClick={onBack} />
        {!title && (
          <MoneyFoxLogo
            size="sm"
            className="pointer-events-none absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2"
          />
        )}
        {title ? (
          <p className="flex-1 text-center text-lg font-bold leading-6 text-mf-neutral-900">
            {title}
          </p>
        ) : null}
        <div className={cn('flex items-center justify-end', title ? 'min-w-9' : '')}>
          {trailing ?? (title ? <span className="size-9" /> : null)}
        </div>
      </div>
      {children ? <div className="relative z-10">{children}</div> : null}
    </header>
  );
}
